module.exports = __webpack_public_path__ + "static/media/new-arrow-down.a08d8c86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/new-arrow-down.svg
// module id = 2679
// module chunks = 0